export default __webpack_public_path__ + "static/media/add-project.ffe94caa.svg";